module.exports = __webpack_public_path__ + "static/20180722_203951_optimized-5de91c8f1db0ce26a2dd876d98290c16.jpg";